import BaseRequestService from "@/modules/core/request/protected/BaseRequestService";
import env from "environment";

class MicroCreditRequestService extends BaseRequestService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/micro-credit/requests"
    });
  }
}

const service = new MicroCreditRequestService();

export default service;
